import { combineReducers } from 'redux';
import authReducer from './authReducer';

export const DRAFT_STAKE = 'stakes/DRAFT_STAKE';
export const EDIT_STAKE = 'stakes/EDIT_STAKE';
export const MY_STAKES_RECEIVE = 'stakes/MY_STAKES_RECEIVED';
export const CHALLENGED_STAKES_RECEIVE = 'stakes/CHALLENGED_STAKES_RECEIVED';
export const STAKE_UPDATING = 'stake/IS_UPDATING';

export const FETCH_USERS_REQUEST = 'users/GET_ALL_REQUEST';
export const FETCH_USERS_SUCCESS = 'users/GET_ALL_SUCCESS';
export const FETCH_USERS_FAILED = 'users/GET_ALL_FAILED';

export const UPDATE_USER_BALANCE = 'user/UPDATE_BALANCE';
export const UPDATE_MY_BALANCE_SUCCESS = 'user/UPDATE_BALANCE_SUCCESS';
export const UPDATE_USER_SUCCESS = 'user/UPDATE_USER_SUCCESS';
export const UPDATE_BALANCE_FAILED = 'user/UPDATE_BALANCE_FAILED';

// export const setStakeUpdating = ({type:})
export const setDraftStake = stake => ({
  type: DRAFT_STAKE,
  payload: { stake }
});

export const setEditStake = (stake, originalStake) => ({
  type: EDIT_STAKE,
  payload: { stake, originalStake }
});

export const setMyStakes = stakes => ({
  type: MY_STAKES_RECEIVE,
  payload: { stakes }
});

export const setChallengedStakes = stakes => ({
  type: CHALLENGED_STAKES_RECEIVE,
  payload: { stakes }
});

export const fetchUsers = () => ({ type: FETCH_USERS_REQUEST });

export const updateUserBalanceAction = (balanceChange, userId) => ({
  type: UPDATE_USER_BALANCE,
  balanceChange,
  userId
});

const initialState = {
  myStakes: [],
  challengedStakes: [],
  users: [],
  availableBalance: 0
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case STAKE_UPDATING: {
      return {
        ...state,
        isUpdating: true
      };
    }
    case DRAFT_STAKE:
      return {
        ...state,
        draftStake: action.payload.stake
      };
    case EDIT_STAKE:
      return {
        ...state,
        editedStake: action.payload.stake,
        editOriginalStake: action.payload.originalStake
      };
    case MY_STAKES_RECEIVE:
      return {
        ...state,
        myStakes: action.payload.stakes
      };
    case CHALLENGED_STAKES_RECEIVE:
      return {
        ...state,
        challengedStakes: action.payload.stakes
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.otherUsers,
        availableBalance: action.payload.currentUser.app_metadata.balance
      };
    case UPDATE_MY_BALANCE_SUCCESS:
      return {
        ...state,
        availableBalance: action.newBalance
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(x => x.user_id === action.updatedProfile.user_id ? action.updatedProfile : x)
      }
    default:
      return state;
  }
};

export default combineReducers({
  auth: authReducer,
  app: rootReducer
});



// WEBPACK FOOTER //
// ./src/App/rootReducer.js